// extracted by mini-css-extract-plugin
var _1 = "Switch_checked__dYhFf";
var _2 = "Switch_container__DFPle";
var _3 = "Switch_knob__8ZPvR";
export { _1 as "checked", _2 as "container", _3 as "knob" }
